export class MsgCursor {
    backward: string;
    forward: string;

    constructor(backward: string, forward: string) {
        this.backward = backward;
        this.forward = forward;
    }
}